import img1 from "../../../src//images/blog/img1.jpg";
import img2 from "../../../src//images/blog/img2.jpg";
import img3 from "../../../src//images/blog/img3.jpg";
import img4 from "../../../src//images/blog/img4.jpg";
import img5 from "../../../src//images/blog/img5.jpg";
import img6 from "../../../src//images/blog/img6.jpg";
import img7 from "../../../src//images/blog/img7.jpg";
import img8 from "../../../src//images/blog/imh8.jpg";
import img9 from "../../../src//images/blog/img9.jpg";
const Data = [
  {
    id: 1,
    img: img1,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 2,
    img: img2,
    title: "  EMR HIPAA Compliance: A Complete Guide for 2023  ",
    des: "  Interested in getting into the nuts and bolts of EMR HIPAA compliance but don’t know where to start? Our new article was written just for that! Get a grasp on this complicated topic without spending hours on it! ",
  },
  {
    id: 3,
    img: img3,
    title: "  Online Pharmacy App Development: Business and Tech Guide  ",
    des: "  Do you plan to create a modern pharmaceutical web or mobile application in 2023? Then this editorial by Light IT Global will be of great use to you! Find out what are the perks of pharma app development, how much it costs, and how to find the perfect team to get the job done! ",
  },
  {
    id: 4,
    img: img4,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 5,
    img: img5,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 6,
    img: img6,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 7,
    img: img7,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 8,
    img: img8,
    title: " EHR Implementation Cost Breakdown: What You Need to Know ",
    des: " The poorly calculated cost of EHR implementation can put the development and adoption process at risk. Too many entrepreneurs either don’t know how the cost of EHR is formed or fail to estimate it. To help you avoid mistakes, Light IT Global has created a comprehensive editorial on the topic. ",
  },
  {
    id: 9,
    img: img9,
    title: "  EMR HIPAA Compliance: A Complete Guide for 2023  ",
    des: "  Interested in getting into the nuts and bolts of EMR HIPAA compliance but don’t know where to start? Our new article was written just for that! Get a grasp on this complicated topic without spending hours on it! ",
  },
];

export default Data;
